import '../../styles/tailwind.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from '../Root';
import { bootstrapTenantRuntime } from './tenantRuntime';
import WorkspaceEntryGate from './WorkspaceEntryGate';

const root = ReactDOM.createRoot(document.getElementById('root'));

export async function startApp() {
  try {
    await bootstrapTenantRuntime();
    root.render(
      <React.StrictMode>
        <WorkspaceEntryGate><Root /></WorkspaceEntryGate>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Application bootstrap failed.', error);
    root.render(
      <React.StrictMode>
        <div style={{ padding: '24px', fontFamily: 'sans-serif' }} role="alert">
          <p>We could not connect to your workspace. Your company setup is saved.</p>
          <button type="button" onClick={startApp}>Try again</button>
        </div>
      </React.StrictMode>
    );
  }
}
